import { NJInlineMessage } from '@engie-group/fluid-design-system-react';
import PrototypeStudioLayout from '@shared/PrototypeStudioLayout';
import Loading from '@shared/Loading';
import type { PrototypeMeta } from '@shared/discoverPrototypes';
import { NetworkShell, PRODUCTION_REF_TABS, Size2MixTabs, TEST_PUC_NETWORK, useSize2MixRefNavigation, type ProductionRefTabId } from '@shared/size2mix-shell';
import FuelsPage from './FuelsPage';
import { useFuels } from './hooks';

export const meta: PrototypeMeta = {
    title: 'Référence — Production › Combustibles',
    description: 'Contrats de combustibles (prix variables, contraintes), taux EnR et polluants du réseau test PUC — création, édition et suppression.',
    tags: ['production', 'reference'],
    author: 'dv5886',
    status: 'reference',
    category: 'production/fuels',
    createdAt: '2026-10-20',
};

export default function RefProductionFuels() {
    const nav = useSize2MixRefNavigation();
    const { data, isLoading, isError, error } = useFuels();

    return (
        <PrototypeStudioLayout title={meta.title}>
            <NetworkShell network={TEST_PUC_NETWORK} activePage="production" onNavigate={nav.onNetworkNavigate} onPrimaryNavigate={nav.onPrimaryNavigate}>
                <Size2MixTabs<ProductionRefTabId> tabs={PRODUCTION_REF_TABS} activeId="fuels" onChange={(id) => nav.goTo(PRODUCTION_REF_TABS.find((tab) => tab.id === id)!.target)} />
                {isError ? (
                    <NJInlineMessage variant="error" title="Chargement impossible">{error.message}</NJInlineMessage>
                ) : isLoading || !data ? <Loading text="Chargement des combustibles" scale="md" /> : <FuelsPage data={data} />}
            </NetworkShell>
        </PrototypeStudioLayout>
    );
}
